import fileValidate from 'helpers/validates/file'

const filterExisting = (fileList, apiFiles) => {
  const filesArray = fileList ? Array.from(fileList) : []

  return (
    Array.isArray(filesArray) &&
    filesArray?.filter((file) => !fileValidate.isFileInList(file, apiFiles))
  )
}

export default filterExisting
